import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";
import { Briefcase } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WorkspaceIndicator() {
  const { user, activeWorkspaceId } = useAuth();
  const [name, setName] = useState("");

  useEffect(() => {
    if (!user || user.account_type !== "agency" || !activeWorkspaceId) { setName(""); return; }
    let cancelled = false;
    axios.get(`${API}/workspaces/${activeWorkspaceId}`, { withCredentials: true })
      .then(r => { if (!cancelled) setName(r.data?.name || ""); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [user, activeWorkspaceId]);

  if (!user || user.account_type !== "agency" || !name) return null;

  const handleClick = () => {
    window.dispatchEvent(new CustomEvent("focus-workspace-switcher"));
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="flex items-center gap-2 px-3 py-1.5 bg-[#1B4FD8]/8 rounded-full border border-[#1B4FD8]/20 hover:bg-[#1B4FD8]/12 transition-colors"
      data-testid="workspace-indicator"
      title="Apri il selettore workspace"
    >
      <Briefcase size={14} weight="duotone" className="text-[#1B4FD8]" />
      <span className="text-xs font-medium text-[#1B4FD8] max-w-[200px] truncate">
        Workspace: {name}
      </span>
    </button>
  );
}
